import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import PageBg from "../../../src/assets/images/auth-bg.png";
import { Link } from "react-router-dom";
import Logo from "../../../src/assets/images/logo.png";
import { useFormik } from "formik";
import { useLocation } from "react-router";
import * as Yup from "yup";

/** Styles */
import "./reset-password.scss";

/** Icons */
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { apiJson } from "../../api/Api";
import { toast } from "react-toastify";

const setPasswordSchema = Yup.object({
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .matches(/[A-Z]/, "Must contain at least one uppercase letter")
    .matches(/[0-9]/, "Must contain at least one number")
    .matches(/[!@#$%^&*]/, "Must contain at least one special character")
    .required("Password is required"),
  password_confirmation: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords do not match")
    .required("Please confirm your password"),
});

const ResetPassword = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const reset_password_token = queryParams.get("reset_password_token");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    document.title = "Reset Password";
  }, []);

  const handleSubmit = (values) => {
    console.log({ reset_password_token, ...values });
    apiJson.auth
      .resetPassword({ reset_password_token, ...values })
      .then((response) => {
        if (response.success) {
          toast.success(
            "Your password has been reset successfully. You can now sign in with your new password",
          );
          props.history.push("/");
        } else {
          toast.error(response.message || "unauthorized access");
        }
      })

      .catch((error) => {
        toast.error(error.message || error);
      });
  };

  const formik = useFormik({
    initialValues: {
      password: "",
      password_confirmation: "",
    },
    validationSchema: setPasswordSchema,
    onSubmit: handleSubmit,
  });

  return (
    <div
      className="setpassword-wrapper"
      style={{ backgroundImage: `url(${PageBg})` }}
    >
      <div className="setpassword-overlay" />

      <Container maxWidth="sm" className="setpassword-container">
        <Paper
          elevation={6}
          className={`setpassword-paper ${isMobile ? "mobile" : ""}`}
        >
          <Box className="setpassword-logo">
            <img src={Logo} alt="Logo" className={isMobile ? "mobile" : ""} />
          </Box>

          <Typography align="center" gutterBottom className="setpassword-title">
            Reset your password
          </Typography>
          <Typography align="center" className="setpassword-subtitle">
            Create a strong password for your account.
          </Typography>
          <form onSubmit={formik.handleSubmit} className="setpassword-form">
            <Box className={`fields ${isMobile ? "mobile" : ""}`}>
              {/* Password */}
              <TextField
                name="password"
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                fullWidth
                variant="outlined"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.password && Boolean(formik.errors.password)
                }
                helperText={formik.touched.password && formik.errors.password}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              {/* Confirm Password */}
              <TextField
                name="password_confirmation"
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm your password"
                fullWidth
                variant="outlined"
                value={formik.values.password_confirmation}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.password_confirmation &&
                  Boolean(formik.errors.password_confirmation)
                }
                helperText={
                  formik.touched.password_confirmation &&
                  formik.errors.password_confirmation
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                        edge="end"
                      >
                        {showConfirmPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              {/* Password strength hints */}
              <Box className="password-rules">
                <Typography
                  className={`rule ${formik.values.password.length >= 8 ? "valid" : ""}`}
                >
                  ✓ At least 8 characters
                </Typography>
                <Typography
                  className={`rule ${/[A-Z]/.test(formik.values.password) ? "valid" : ""}`}
                >
                  ✓ One uppercase letter
                </Typography>
                <Typography
                  className={`rule ${/[0-9]/.test(formik.values.password) ? "valid" : ""}`}
                >
                  ✓ One number
                </Typography>
                <Typography
                  className={`rule ${/[!@#$%^&*]/.test(formik.values.password) ? "valid" : ""}`}
                >
                  ✓ One special character (!@#$%^&*)
                </Typography>
              </Box>

              <Button
                type="submit"
                variant="contained"
                color="primary"
                size={isMobile ? "medium" : "large"}
                fullWidth
              >
                Reset Password
              </Button>
            </Box>
          </form>
        </Paper>
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => ({
  width: state.layout.screenWidth,
});

export default withRouter(connect(mapStateToProps)(ResetPassword));
